module.exports = __webpack_public_path__ + "aa87a685ac0923cbcde989da0a48f63d.svg";